module.exports = __webpack_public_path__ + "a75563d7b9e5b1db163971b9a2e66216.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBold.woff
// module id = 369
// module chunks = 0